<div class="mx-4 mt-4 fadein">
    <div class="page-header mb-4">
        <div class="flex justify-content-between align-items-center mb-3">
            <h2 class="m-0">Resumen Ítems de Ensayo</h2>
            <p-button icon="pi pi-arrow-left" label="Volver a Inventario" [routerLink]="['/inventory/items']" severity="secondary" [text]="true"></p-button>
        </div>
        <p class="page-subtitle m-0">Vista especializada para Patrones de Referencia y Reactivos de Análisis.</p>
    </div>

    <div class="surface-card shadow-2 border-round p-4">
        <table-dynamic
            [config]="{
                title: 'Ítems de Ensayo',
                columns: cols(),
                data: data(),
                totalRecords: totalRecords(),
                first: first(),
                showFilters: true,
                selectable: false,
                globalFilterFields: ['name', 'internal_code', 'lot_number', 'brand.name'],
                loading: loading(),
                localFilter: false,
                lazy: true,
                showPagination: true,
                pageSize: pageSize()
            }"
            (onLazyLoad)="loadData($event)"
            (onPageChange)="loadData($event)"
            (onAction)="handleTableAction($event)"
            (onEdit)="handleEdit($event)"
            (onNew)="handleNew()"
            [actionButtons]="actionButtons">
        </table-dynamic>
    </div>
</div>

<!-- Diálogo para mostrar la composición completa -->
<p-dialog
    header="Composición Completa"
    [(visible)]="showCompositionDialog"
    [modal]="true"
    [style]="{width: '50vw'}"
    [draggable]="false"
    [resizable]="false">

    <p-table [value]="selectedItemComposition()" [tableStyle]="{'min-width': '100%'}">
        <ng-template pTemplate="header">
            <tr>
                <th>Analito</th>
                <th>Concentración</th>
                <th>Unidad</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-comp>
            <tr>
                <td>{{comp.name || comp.analite_name || '-'}}</td>
                <td>{{comp.concentration}}</td>
                <td>{{ getUnitLabel(comp.unit_id) }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="3" class="text-center">No hay composición definida.</td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
